<div name="choose-supplier">
  <div class="col-xs-12 choose-suppliers modal-supplier-div">
    <div class="row" *ngIf="isNonDraftSurvey && isAidaEnabled">
      <div
        class="alert alert-warning text-center col-sm-10 col-md-9 col-sm-offset-2"
        role="alert"
      >
        AIDA™ is activated in this survey. Most of the supplier allocation
        features are disabled. To have full access to your survey disable AIDA™
        from “Edit Details” page.
      </div>
    </div>
    <div class="row">
      <div class="col-sm-10 col-md-8 col-sm-offset-2">
        <h4 psUiModalTitle class="text-center mb30">Choose your Suppliers</h4>
        <p class="text-center">
          We evenly distribute your completes to each supplier. To edit, click
          in the Allocation fields and change your quantity by numbers or
          percentages.
        </p>
      </div>
    </div>

    <div class="row">
      <div
        class="col-sm-10 col-md-8 col-sm-offset-2 edit-supplier-action-button"
      >
        <button
          class="btn btn-primary btn-sm button-supplier"
          type="button"
          (click)="clearAllSuppliers()"
          [disabled]="isNonDraftSurvey && isAidaEnabled"
        >
          Clear All
        </button>

        <button
          class="btn btn-primary btn-sm button-supplier"
          type="button"
          (click)="distributeSuppliers()"
          psUiHotjarEvent
          trackOn="click"
          eventName="Choose Your Supplier - Allocations"
          [disabled]="isNonDraftSurvey && isAidaEnabled"
        >
          Distribute
        </button>
        <button
          class="btn btn-primary btn-sm button-supplier"
          type="button"
          (click)="selectAllSuppliers()"
          psUiHotjarEvent
          trackOn="click"
          eventName="Choose Your Supplier - Allocations"
          [disabled]="isNonDraftSurvey && isAidaEnabled"
        >
          {{ isAllSuppliersSelected() ? 'Unselect all' : 'Select All' }}
        </button>
        <span
          *ngIf="showSupplierGroupingButton"
          [ngClass]="{ 'disable-not-allowed': !enableGroupingButton }"
        >
          <div class="btn-group">
            <button
              class="btn btn-primary btn-sm button-supplier button-supplier-group"
              type="button"
              (click)="openModalGroup()"
              [disabled]="
                !enableGroupingButton || (isNonDraftSurvey && isAidaEnabled)
              "
              *ngIf="!showUngroupButton"
              psUiHotjarEvent
              trackOn="click"
              eventName="Choose Your Supplier - Supplier Grouping"
            >
              Group Suppliers
            </button>
            <ps-ui-select-dropdown
              class="groupTemplateDrop"
              *ngIf="!showUngroupButton"
              [enableSearch]="false"
              [loading]="false"
              labelNone=" "
              label=" "
              [dropdownItems]="groupedSuppTemplates"
              [field]="'groupName'"
              (selectedItem)="selectSupplierGroupTemplate($event)"
              [disabled]="isNonDraftSurvey && isAidaEnabled"
            >
            </ps-ui-select-dropdown>
          </div>
          <button
            class="btn btn-primary btn-sm button-supplier"
            type="button"
            *ngIf="showUngroupButton"
            (click)="ungroupSupplierGroup()"
          >
            Ungroup
          </button>
        </span>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="row" [ngClass]="{ 'main-content': showFooter }">
      <div class="col-sm-2 col-md-2" *ngIf="!showSupplierManualOverride"></div>
      <div
        [ngClass]="
          showSupplierManualOverride
            ? 'col-sm-10 col-md-10'
            : 'col-sm-8 col-md-8'
        "
        class="choose-suppliers-table"
      >
        <div class="table">
          <table class="table">
            <thead>
              <tr>
                <th class="country-th" colspan="2">
                  <div *ngIf="isMcSvpSurvey">
                    <ps-ui-select-dropdown
                      [dropdownItems]="mcSpvChildsDropdownData"
                      [field]="'country_name'"
                      [enableSearch]="false"
                      class="uppercase mccountry-dropdown"
                      labelAlignment="start"
                      [sortBySelected]="true"
                      [showFlag]="true"
                      [flagCountryCodeField]="'country_code'"
                      [flagLanguageCodeField]="'language_code'"
                      [(ngModel)]="selectedMcSpvChild"
                      (selectedItem)="selectMcSvpChild($event)"
                    >
                    </ps-ui-select-dropdown>
                  </div>
                </th>
                <th>
                  <span *psUiConfigEnabled="'enableSupplierGrouping'">
                    <div
                      class="user-options"
                      *ngIf="blendSupplierGroups?.listOfOptions?.length"
                    >
                      <ps-ui-select-dropdown
                        class="d-block blend-dropdown-width"
                        [dropdownItems]="blendSupplierGroups.listOfOptions"
                        [field]="'config_name'"
                        [loading]="loadingBlends"
                        [enableSearch]="false"
                        labelNone="-- Choose Supplier Blend --"
                        [(ngModel)]="selectedBlend"
                        (selectedItem)="selectBlend($event)"
                        psUiHotjarEvent
                        trackOn="click"
                        eventName="Choose Your Supplier - Supplier Blends"
                        data-e2e="edit-supplier-supplier-blends-listing"
                        [disabled]="isNonDraftSurvey && isAidaEnabled"
                      >
                      </ps-ui-select-dropdown>
                    </div>
                    <div
                      class="user-options"
                      *ngIf="!blendSupplierGroups?.listOfOptions?.length"
                    >
                      <ps-ui-select-dropdown
                        class="d-block blend-dropdown-width"
                        [dropdownItems]="blendSupplierGroupEmpty"
                        [field]="'config_name'"
                        [loading]="loadingBlends"
                        [enableSearch]="false"
                        labelNone="Choose Supplier Blend Empty"
                        [(ngModel)]="selectedBlend"
                        (selectedItem)="selectBlend($event)"
                        psUiHotjarEvent
                        trackOn="click"
                        eventName="Choose Your Supplier - Supplier Blends"
                        [disabled]="isNonDraftSurvey && isAidaEnabled"
                      >
                      </ps-ui-select-dropdown>
                    </div>
                  </span>
                </th>
                <th
                  class="text-center supp-cpi-edit"
                  *ngIf="showSupplierManualOverride"
                >
                  Suppliers CPI
                </th>
                <th class="text-center" *ngIf="showSupplierManualOverride">
                  Margin
                </th>
                <th
                  colspan="3"
                  class="text-center"
                  *ngIf="showSupplierManualOverride"
                >
                  EPC Values
                </th>
                <th
                  class="text-center supp-cpi-edit"
                  *ngIf="!showSupplierManualOverride"
                  [ngClass]="{
                    'hide-supp-cpi': !showSupplierCPIColumn
                  }"
                >
                  CPI
                </th>
                <th class="text-center">FEASIBILITY</th>
                <th colspan="2" class="text-center">ALLOCATION</th>
                <th
                  colspan="3"
                  class="supplier-allocation-flexibilty text-center"
                >
                  <p>FLEXIBILITY</p>
                  <div style="display: flex; flex-direction: row">
                    <ps-ui-select-dropdown
                      class="flexibility-dropdown-width"
                      [dropdownItems]="flexibilityStatus"
                      [field]="'value'"
                      [enableSearch]="false"
                      (selectedItem)="setFlexibilityType($event)"
                      [(ngModel)]="flexibilitySelectedType"
                      data-e2e="flexibility-dropdown-list"
                      [disabled]="isNonDraftSurvey && isAidaEnabled"
                    >
                    </ps-ui-select-dropdown>
                    <span class="flexibilityLable">
                      <label class="status pull-middle quota-flex-btn">
                        <span class="mx-1">by</span>
                      </label>
                      <span>
                        <input
                          type="number"
                          class="text-line disabled-state"
                          [ngClass]="{
                            'invalid-val': supplierFlex.value > 100,
                            blank: flexibilitySelectedType.key === 1
                          }"
                          maxlength="3"
                          [(ngModel)]="supplierFlex.value"
                          [readonly]="!supplierFlex.isFlexible"
                          psUiHotjarEvent
                          trackOn="change"
                          eventName="Choose Your Supplier - Flexibility"
                          (keyup)="
                            updateFlexValue(supplierFlex.value); removeBlends()
                          "
                          [disabled]="
                            flexibilitySelectedType.key !== 0 ||
                            (isNonDraftSurvey && isAidaEnabled)
                          "
                          data-e2e="flexibility-input"
                        /><span>%</span>
                      </span>
                    </span>
                  </div>
                </th>
              </tr>
              <tr class="text-center">
                <td
                  [attr.colspan]="showSupplierManualOverride ? '5' : '4'"
                ></td>
                <td *ngIf="showSupplierManualOverride" class="epc-labels">
                  Platform
                </td>
                <td *ngIf="showSupplierManualOverride" class="epc-labels">
                  Estimate
                </td>
                <td *ngIf="showSupplierManualOverride" class="epc-labels">
                  Actual
                </td>
                <td></td>
                <td class="allocation-table-header">Quantity</td>
                <td class="allocation-table-header">Percentage</td>
                <td
                  class="allocation-table-header"
                  *ngIf="flexibilitySelectedType.key === 1"
                >
                  Flexibility
                </td>
                <td>Min</td>
                <td>Max</td>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text-center CP"
                *ngFor="let supplier of suppliers; let i = index"
                [ngClass]="{
                  selected:
                    supplier.isValid === true ? supplier.setActive : false,
                  preferred: supplier.supplrSt === 'P',
                  inactive: !supplier.isValid
                }"
                (click)="selectSupplierRow($event, supplier)"
              >
                <td class="taLeft" colspan="3">
                  <a
                    [ngClass]="{ 'hide-div': !supplier.group_name }"
                    class="fa fa-edit edit-group mx-2"
                    (click)="openEditModal(supplier)"
                  ></a>
                  <span
                    >{{
                      supplier.group_name
                        ? supplier.group_name
                        : supplier.suppliers[0].name
                    }}
                  </span>
                  <ps-ui-pds-label
                    *ngIf="supplier.is_pds_applied"
                    [supplierId]="supplier.suppliers[0].id"
                    [cpi]="supplier.cpi"
                    [fee]="supplier.fee"
                  ></ps-ui-pds-label>
                </td>
                <td class="supp-cpi-edit" *ngIf="showSupplierManualOverride">
                  <span class="currenycSymbol">
                    <!--PD-9295 always shows scpi in dollars-->
                    $
                  </span>
                  <span
                    id="override_selective_cpi_value"
                    class="text-input"
                    ngDefaultControl
                    strip-br="true"
                    strip-tags="true"
                    [attr.contenteditable]="manualScpiOverrideEnabled"
                    (focusout)="
                      validateSelectiveManualOverrideRules('button', i)
                    "
                    [ngClass]="{
                      'input-error':
                        (supplier.scpi || 0) > maxCpiThershold &&
                        manualScpiOverrideEnabled,
                      supplierCpiSpan: manualScpiOverrideEnabled
                    }"
                  >
                    <input
                      style="background-color: transparent; border: none"
                      (click)="selectInput($event)"
                      type="number"
                      class="supplierCpiInput"
                      [ngModel]="
                        (supplier.scpi | number : '1.0-2')?.replace(',', '')
                      "
                      (ngModelChange)="supplier.scpi = $event"
                      [disabled]="!manualScpiOverrideEnabled"
                      [ngClass]="{ activSupplierCpi: supplier.setActive }"
                      attr.data-e2e="edit-supplier-{{
                        supplier.group_ref ?? supplier.suppliers[0].id
                      }}-scpi-input"
                      psUiInputDecimalRestriction
                      psUiToNumber
                    />
                  </span>
                </td>
                <td *ngIf="showSupplierManualOverride">
                  {{ supplier?.variable_margin }}%
                </td>
                <td *ngIf="showSupplierManualOverride">
                  <span class="currenycSymbol"> $ </span
                  >{{ supplier?.platform_epc }}
                </td>
                <td *ngIf="showSupplierManualOverride">
                  <span class="currenycSymbol"> $ </span
                  >{{ supplier?.estimate_epc }}
                </td>
                <td *ngIf="showSupplierManualOverride">
                  <span class="currenycSymbol"> $ </span
                  >{{ supplier?.actual_epc }}
                </td>
                <td
                  class="supp-cpi-edit"
                  *ngIf="!showSupplierManualOverride"
                  [ngClass]="{
                    'hide-supp-cpi': !showSupplierCPIColumn
                  }"
                >
                  <span class="currenycSymbol"
                    >{{ supplier?.currency_symbol }}
                  </span>
                  <span
                    id="override_selective_cpi_value"
                    class="text-input"
                    ngDefaultControl
                    strip-br="true"
                    strip-tags="true"
                    [attr.contenteditable]="isOperatorOverideEdit"
                    [ngModel]="supplier.cpi | number : '1.0-2'"
                    (ngModelChange)="supplier.cpi = $event"
                    #ctrl="ngModel"
                    (focusout)="
                      validateSelectiveManualOverrideRules('modal', i)
                    "
                    [ngClass]="{
                      'input-error':
                        supplier.cpi > maxCpiThershold && isOperatorOverideEdit,
                      supplierCpiSpan: isOperatorOverideEdit
                    }"
                  >
                    <input
                      (click)="selectInput($event)"
                      (blur)="formatCpi(supplier.cpi, i)"
                      type="text"
                      class="supplierCpiInput"
                      [(ngModel)]="supplier.cpi"
                      [disabled]="!isOperatorOverideEdit"
                      [ngClass]="{ activSupplierCpi: supplier.setActive }"
                      (change)="updateSupplierCpi(i)"
                      psUiInputDecimalRestriction
                      psUiToNumber
                      attr.data-e2e="edit-supplier-{{
                        supplier.suppliers[0].id
                      }}-manual-override-input"
                    />
                  </span>
                </td>
                <td class="feasibility-border">
                  <div>
                    <span class="text-center">
                      {{ supplier.feasibility | zeroDash : '1.0-2' }}
                    </span>
                    <div
                      class="setting-info feasibility-tooltip"
                      *ngIf="
                        supplier.feasibility && supplier.unUsedQual?.length
                      "
                    >
                      <i
                        class="fa fa-exclamation-triangle unused-qual-tooltip-icon"
                        aria-hidden="true"
                      ></i>
                      <p>Unused Qualifications : {{ supplier.unUsedQual }}</p>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="supplier.group_name"
                  class="white-block supplier-allocation-quantity"
                >
                  <input
                    oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                    type="number"
                    class="form-control"
                    name="quantity"
                    [(ngModel)]="supplier.quantity"
                    (change)="allocationValueUpdate(i)"
                    [disabled]="
                      !supplier.is_active || (isNonDraftSurvey && isAidaEnabled)
                    "
                    attr.data-e2e="edit-supplier-{{
                      supplier.group_ref
                    }}-allocation-input"
                  />
                </td>
                <td
                  *ngIf="!supplier.group_name"
                  class="white-block supplier-allocation-quantity"
                >
                  <input
                    type="number"
                    class="form-control color-patch"
                    [(ngModel)]="supplier.quantity"
                    (change)="allocationValueUpdate(i)"
                    [disabled]="
                      !supplier.is_active || (isNonDraftSurvey && isAidaEnabled)
                    "
                    attr.data-e2e="edit-supplier-{{
                      supplier.suppliers[0].id
                    }}-allocation-input"
                    psUiInputRestriction="[0-9]"
                    psUiToNumber
                  />
                </td>
                <td class="white-block">
                  <input
                    id="supplier-{{
                      supplier.suppliers[0].id
                    }}-allocation-percentage"
                    type="text"
                    class="form-control color-patch"
                    [(ngModel)]="supplier.percentile"
                    (change)="allocationPercentileUpdate(i)"
                    [disabled]="
                      !supplier.is_active || (isNonDraftSurvey && isAidaEnabled)
                    "
                    psUiInputRestriction="[0-9]"
                    psUiToNumber
                  />
                </td>
                <td
                  class="white-block"
                  *ngIf="flexibilitySelectedType.key === 1"
                >
                  <input
                    type="text"
                    class="form-control color-patch"
                    [(ngModel)]="supplier.flexValue"
                    (change)="updateSupplierFlexibility(i)"
                    psUiInputRestriction="[0-9]"
                    psUiToNumber
                    *ngIf="flexibilitySelectedType.key === 1"
                  />
                </td>
                <td>
                  {{ supplier.min ? supplier.min : 0 }}
                </td>
                <td>
                  {{ supplier.max ? supplier.max : 0 }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="text-center">
                <td
                  [attr.colspan]="showSupplierManualOverride ? '8' : '4'"
                ></td>
                <td colspan="1">
                  Total Feasibility:<span class="total"
                    >{{ totalFeasibility | zeroDash : '1.0-2' }}
                  </span>
                </td>
                <td colspan="2">
                  Total Remaining:
                  <span class="total" id="total-remaining-goal"
                    >{{
                      totalRemaining ? (totalRemaining | zeroDash : '1.0-2') : 0
                    }}
                  </span>
                </td>
                <td colspan="2"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div
        class="col-sm-2 col-md-2 pause-survey-cpi"
        [hidden]="hidePricesAcordion"
      >
        <div>
          <ps-ui-accordion [closeOthers]="true">
            <ps-ui-accordion-section
              class="pause-menu"
              id="pause-threshold-accordion"
              title="Pause"
              tooltipText="Pause Threshold determines the average CPI value that will cause a survey to Pause.&#10;By default this will be the average CPI based on supplier allocation, but can be customized based on your project requirements."
            >
              <p
                *ngIf="
                  !manualOverrideMdl &&
                  !operatorOverrideMdl &&
                  !disablesurveyPauseThreshold &&
                  !(isNonDraftSurvey && isAidaEnabled)
                "
              >
                Don't pause until :<input
                  id="survey-pause-threshold"
                  type="number"
                  min="0"
                  [(ngModel)]="surveyPauseThreshold"
                  (change)="surveyPauseThresholdUpdate()"
                  (keyup)="surveyPauseThresholdUpdate()"
                />
                CPI
              </p>
              <p
                *ngIf="
                  manualOverrideMdl ||
                  operatorOverrideMdl ||
                  disablesurveyPauseThreshold ||
                  (isNonDraftSurvey && isAidaEnabled)
                "
              >
                Don't pause until :<input
                  id="survey-pause-threshold-disabled"
                  class="inputDisabled"
                  type="number"
                  [disabled]="true"
                  min="0"
                />
                CPI
              </p>
            </ps-ui-accordion-section>
          </ps-ui-accordion>

          <div *ngIf="userType === 'operator'; else priceOverrideContent">
            <ng-container
              *ngTemplateOutlet="priceOverrideTemplate"
            ></ng-container>
          </div>
          <ng-template #priceOverrideContent>
            <div *psUiConfigEnabled="'overridCmp'">
              <ng-container
                *ngTemplateOutlet="priceOverrideTemplate"
              ></ng-container>
            </div>
          </ng-template>

          <ng-template #priceOverrideTemplate>
            <ps-ui-accordion
              [closeOthers]="true"
              *ngIf="
                !showSupplierManualOverride &&
                !surveyDetails.is_qbp_enable &&
                !isPurePriceApplied
              "
              data-e2e="edit-supplier-override-accordion"
            >
              <ps-ui-accordion-section
                class="pause-menu operator-menu"
                id="operator-override-accordion"
                title="Operator Override"
                tooltipText="Selective Manual Override allows you to set a new CPI for individual suppliers. CPI will update all suppliers with the same CPI. NOTE: When either override is enabled they will disable the Pause feature."
                [ngClass]="{
                  priceMultiplierAdded: isPriceMultiplierAdded,
                  disabled: isAidaEnabled
                }"
              >
                <div class="manual_overide">
                  <p id="supplier-rates" *psUiConfigEnabled="buyerconfigObject">
                    <input
                      type="checkbox"
                      id="selectSupplierRates"
                      [(ngModel)]="supplierRates"
                      (change)="
                        updateManualOverrideControl();
                        setPurepriceRateCardPricing()
                      "
                      [disabled]="isNonDraftSurvey && isAidaEnabled"
                    />
                    <label for="selectSupplierRates"> Supplier Rates </label>
                  </p>
                </div>
                <div class="manual_overide">
                  <div class="priceMultiplierDiv">
                    <div class="manualOverride d-flex align-items-start gap-1">
                      <input
                        type="checkbox"
                        id="selectManualOverride"
                        [(ngModel)]="manualOverrideMdl"
                        (change)="updateManualOverrideControl()"
                        psUiHotjarEvent
                        trackOn="change"
                        eventName="Choose Your Supplier - Selective Manual Override"
                        data-e2e="edit-supplier-manual-override-checkbox"
                        [disabled]="isAidaEnabled"
                      />
                      <label for="selectManualOverride">
                        Selective Manual Override
                      </label>
                      <ps-ui-aida-feature-unavailable-tooltip
                        [isAidaEnabled]="isAidaEnabled"
                        direction="left"
                      ></ps-ui-aida-feature-unavailable-tooltip>
                    </div>
                  </div>
                  <p>
                    Override CPI:
                    <input
                      type="text"
                      #overRideCpi
                      [ngClass]="{ inputDisabled: !disableOverrideCpiInput }"
                      [disabled]="!disableOverrideCpiInput"
                      step="0.01"
                      min="0"
                      id="override_cpi_value"
                      [(ngModel)]="operatorOverrideCpi"
                      (focusout)="validateOverrideCPIRules()"
                      psUiInputDecimalRestriction
                      psUiToNumber
                      psUiHotjarEvent
                      trackOn="input"
                      eventName="Choose Your Supplier - Price Override"
                    />
                  </p>
                  <div
                    class="mt-1 priceMultiplierDiv"
                    *ngIf="isMcSvpSurvey && !manualOverrideMdl"
                  >
                    <p id="mcQbOveride">
                      <input
                        type="checkbox"
                        id="selectMcQbOverride"
                        [(ngModel)]="mcQbOverrideMdl"
                        (change)="setMcQbOverrideMdl()"
                      />
                      <label for="selectMcQbOverride" class="d-inline">
                        Use same CPI for all locales
                      </label>
                    </p>
                  </div>
                </div>
                <div
                  id="confirm-selective-cpi"
                  [ngClass]="{
                    'hide-container': !containerSelectiveConfirmCPIBtn
                  }"
                >
                  <p class="text-center">
                    Please confirm the Selective Manual Override CPI value(s)
                    you have entered are accurate.
                  </p>
                  <div class="text-center selective-btn">
                    <button
                      class="btn btn-primary"
                      type="button"
                      (click)="userConfirmedCPI()"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
                <div
                  id="confirm-cpi"
                  [ngClass]="{ 'hide-container': !containerConfirmCPIBtn }"
                >
                  <p class="text-center">
                    Please confirm the Override you have entered is accurate.
                  </p>
                  <div class="text-center selective-btn">
                    <button
                      class="btn btn-primary"
                      type="button"
                      (click)="userConfirmedCPI()"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </ps-ui-accordion-section>
            </ps-ui-accordion>
          </ng-template>

          <ps-ui-accordion
            [closeOthers]="true"
            *ngIf="
              showSupplierManualOverride &&
              !surveyDetails.is_qbp_enable &&
              !isPurePriceApplied
            "
          >
            <ps-ui-accordion-section
              class="pause-menu supplier-menu"
              title="Mannual Supplier Override"
              [ngClass]="{ priceMultiplierAdded: isPriceMultiplierAdded }"
              [isExpanded]="
                manualScpiOverrideEnabled ? manualScpiOverrideEnabled : false
              "
            >
              <div class="manual_overide">
                <div class="priceMultiplierDiv">
                  <div class="manualOverride d-flex align-items-start gap-1">
                    <input
                      type="checkbox"
                      id="supplierManualOverride"
                      [(ngModel)]="manualScpiOverrideEnabled"
                      (change)="updateManualScpiOverrideControl()"
                      [disabled]="isAidaEnabled"
                    />
                    <label for="supplierManualOverride"
                      >Selective Manual Override</label
                    >
                    <ps-ui-aida-feature-unavailable-tooltip
                      [isAidaEnabled]="isAidaEnabled"
                      direction="left"
                    ></ps-ui-aida-feature-unavailable-tooltip>
                  </div>
                </div>
              </div>
              <div
                id="confirm-selective-cpi"
                [ngClass]="{
                  'hide-container': !containerSelectiveConfirmCPIBtn
                }"
              >
                <p class="text-center">
                  Please confirm the Selective Manual Override CPI value(s) you
                  have entered are accurate.
                </p>
                <div class="text-center selective-btn">
                  <button
                    class="btn btn-primary"
                    type="button"
                    (click)="userConfirmedCPI()"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </ps-ui-accordion-section>
          </ps-ui-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
<ps-ui-footer
  [currentPage]="'SUPPLIER'"
  [cpiOverrideConfirmationState]="cpiOverrideConfirmationState"
  [selectedMcSpvChild]="selectedMcSpvChild"
  *ngIf="showFooter"
></ps-ui-footer>
